<template>

	<div class="box size30">
		<h2>Add new market environment</h2>
		<div class="success-message" :class="{ 'hidden' : !success }">Market environment has successfully been created.

			<div class="more-info">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 426.667 426.667" xml:space="preserve">
					<path d="M213.333,0C95.467,0,0,95.467,0,213.333s95.467,213.333,213.333,213.333S426.667,331.2,426.667,213.333S331.2,0,213.333,0z M234.667,320H192V192h42.667V320z M234.667,149.333H192v-42.667h42.667V149.333z"/>
				</svg>
				<ul>
					<li v-for="feedback in successFeedback" :key="feedback.id">{{ feedback }}</li>
				</ul>
			</div>

		</div>
		<div class="error-message" :class="{ 'hidden' : !error }">{{errorMessage}}</div>
		<form data-module="false" v-on:submit.prevent="submitMarketClickHandler" novalidate>
			<ul class="form conditional-container">
				<li class="size100">
					<label for="source">Source to copy from</label>
					<div class="selector">
						<select name="source" id="source" v-model="source" required ref="marketSelector">
							<option value="">Pick a market</option>
							<template v-for="(market, key) in markets">
								<option v-bind:key="key" :value="key">{{market}}</option>
							</template>
						</select>
					</div>
				</li>
				<li class="size100">
					<label>Country code</label> <input type="text" placeholder="E.g.: DE" required pattern="^[A-Z]{2}$" v-model="countryCode" name="country_code">
				</li>
				<li>
					<h3 style="margin: 20px 0 0 0">Language(s)</h3>
				</li>
				<li class="size75">
					<label>Language 1</label> <input type="text" pattern="\S{2,}" v-model="lang1.name" placeholder="E.g.: Deutsch" name="lang_1" required>
				</li>
				<li class="size25">
					<label>Language code</label> <input type="text" pattern="^[a-z]{2}$" v-model="lang1.code" placeholder="E.g.: de" name="lang_code_1" required>
				</li>
				<li class="size75">
					<label>Language 2</label> <input type="text" pattern="\S{2,}" v-model="lang2.name" name="lang_2">
				</li>
				<li class="size25">
					<label>Language code</label> <input type="text" pattern="^[a-z]{2}$" v-model="lang2.code" name="lang_code_2">
				</li>
				<li class="size75">
					<label>Language 3</label> <input type="text" pattern="\S{2,}" v-model="lang3.name" name="lang_3">
				</li>
				<li class="size25">
					<label>Language code</label> <input type="text" pattern="^[a-z]{2}$" v-model="lang3.code" name="lang_code_3">
				</li>
				<li>
					<h3 style="margin: 20px 0 0 0">Create new user for this environment</h3>
				</li>
				<li>
					<label>User email (login)</label> <input type="email" pattern="^([a-zA-Z0-9]+([\.+_-][a-zA-Z0-9]+)*)@(([a-zA-Z0-9]+((\.|[-]{1,2})[a-zA-Z0-9]+)*)\.[a-zA-Z]{2,6})$" v-model="newUser.username" name="email" required>
				</li>
				<li class="size50">
					<label>Password</label> <input type="password" v-model="newUser.password" pattern="\S{2,}" name="password_1" required>
				</li>
				<li class="size50">
					<label>Password repeat</label> <input type="password" v-model="newUser.password2" pattern="\S{2,}" name="password_2" required>
				</li>
				<li v-if="notMatchingPasswords">
					<p style="color:#f00;">Passwords must be identical!</p>
				</li>
			</ul>

			<br>
			<button class="btn">Submit</button>
		</form>
	</div>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'
import validation from '../../modules/forms/validation.js'

export default {
	name: 'marketenvironment',
	props: ['markets'],

	data () {
		return {
			source: '',
			users: null,
			countryCode: null,
			lang1: {
				name: null,
				code: null
			},
			lang2: {
				name: null,
				code: null
			},
			lang3: {
				name: null,
				code: null
			},
			newUser: {
				username: null,
				password: null,
				password2: null
			},
			predefinedUser: '',
			notMatchingPasswords: false,
			error: false,
			success: false,
			successFeedback: null,
			errorMessage: null
		}
	},

	created () {
		this.int = 0
		this.fetchData()
	},

	methods: {
		fetchData () {
			var url = '/cms/api/instances?where[entity]=users'
			xhrModule.get(url, this.getUsersCompleteHandler.bind(this))

			var url1 = '/cms/api/instances?where[entity]=roles'
			xhrModule.get(url1, this.getRolesCompleteHandler.bind(this))
		},

		getRolesCompleteHandler (data) {
			this.roles = data.data
			this.filter()
		},

		getUsersCompleteHandler (data) {
			this.tempUsers = data.data
			this.filter()
		},

		filter () {
			this.int++
			if (this.int !== 2) return
			// we get a user for each translation so we need to only fetch 1 per UUID
			var filteredUsers = []
			var foundUUIDs = []
			this.int = 0

			for (var i = 0; i < this.tempUsers.length; i++) {
				var uuid = this.tempUsers[i].uuid
				// Filter out our admin user and also the unauthenticated user
				if (this.tempUsers[i].data.username.value === 'admin@three-sixty.be' || this.tempUsers[i].data.username.value === 'unauthenticated') continue

				// Filter out all users that have a roche role and / or an "admin_xx" role
				var roles = this.tempUsers[i].data.roles.value
				var translatedRoles = []
				for (var r = roles.length - 1; r >= 0; r--) {
					for (var role in this.roles) {
						if (roles[r] === this.roles[role].uuid) {
							translatedRoles.push(this.roles[role].data.name.value)
						}
					}
				}

				if (translatedRoles.indexOf('Global admin') > -1) continue
				if (translatedRoles.indexOf('Roche Admin') > -1) continue
				var abort = false
				for (var t = translatedRoles.length - 1; t >= 0; t--) {
					if (translatedRoles[t].match('admin_')) {
						abort = true
						break
					}
				}
				if (!abort) {
					// search for the UUID in our foundUUIDs array
					// if we have not found it we can add it
					var index = foundUUIDs.indexOf(uuid)

					if (index === -1) {
						foundUUIDs.push(uuid)
						filteredUsers.push(this.tempUsers[i])
					}
				}

				if (i === this.tempUsers.length - 1) {
					this.users = filteredUsers
				}
			}
		},

		submitMarketClickHandler (e) {
			e.preventDefault()
			var form = e.target
			var valid = validation.validate(form)
			if (!valid) return

			// check if both passwords are identical
			if (!this.predefinedUser) {
				if (this.newUser.password !== this.newUser.password2) {
					this.notMatchingPasswords = true
					return
				} else {
					this.notMatchingPasswords = false
				}
			}

			// prepare data
			var data = {}
			data['source'] = this.source
			data['markets'] = {}

			if (this.lang1.name) {
				data['markets'][this.lang1.code + '_' + this.countryCode] = this.lang1.name
			}

			if (this.lang2.name) {
				data['markets'][this.lang2.code + '_' + this.countryCode] = this.lang2.name
			}

			if (this.lang3.name) {
				data['markets'][this.lang3.code + '_' + this.countryCode] = this.lang3.name
			}

			var user = {}
			if (this.predefinedUser) {
				user['uuid'] = this.predefinedUser
			} else {
				user['username'] = this.newUser.username
				user['password'] = this.newUser.password
			}

			data['user'] = user

			var json = JSON.stringify(data)
			var url = '/cms/api/copyMarketData'
			xhrModule.post(url, json, this.postMarketCompleted.bind(this), this.postMarketFailed.bind(this))

			this.$el.parentNode.classList.add('loading')
		},

		postMarketCompleted (data) {
			this.$el.parentNode.classList.remove('loading')
			this.success = true
			this.error = false
			this.successFeedback = data.feedback
		},

		postMarketFailed (data) {
			this.$el.parentNode.classList.remove('loading')
			this.success = false
			this.error = true
			this.successFeedback = null
			this.errorMessage = 'Something went wrong. Please check if you have entered an existing country code or username.'
		}
	}
}

</script>
